export default __webpack_public_path__ + "static/media/030_corner1.vp9.2130f368.webm";